export const publicApiMgmtEndpoints = {
  readmeDocsLogin: { method: 'get', path: '/docs/login' },
  createClient: { method: 'post', path: '/clients' },
  getClients: { method: 'get', path: '/clients' },
  updateClient: { method: 'post', path: '/clients/{clientId}' },
  deleteClient: { method: 'post', path: '/clients/{clientId}/delete' },
  createApp: { method: 'post', path: '/apps' },
  updateApp: { method: 'post', path: '/apps/{appId}' },
  deleteApp: { method: 'post', path: '/apps/{appId}/delete' },
} as const
